// Данные, без которых приложение не может нарисовать первую страницу: язык, привязка к приложению (QR),
// список элементов, чанк текущей страницы и — на странице элемента — данные этого элемента. Запросы стартуют сразу при загрузке
// бандла и идут параллельно (раньше — по цепочке: язык → check_auth → /periodic/all → рендер → элемент).
import { fetchIsAuth, getAuthCookie } from '../hooks/useAuth';
import { getAllElements } from './getAllElements';
import { preloadPageForPath } from '../pages/lazyPages';
import { NO_LANG_PATHS, applyLanguage, buildPath, detectLanguage, parsePath } from './language';

// Язык берётся из URL (/ru/element/1). Адресу без языкового префикса он добавляется:
// сохранённый выбор, затем язык браузера, затем английский.
const getInitialLanguage = () => {
  const { pathname, search, hash } = window.location;
  if (NO_LANG_PATHS.includes(pathname)) {
    return detectLanguage();
  }
  const { lang } = parsePath(pathname);
  if (lang) {
    return lang;
  }
  const detected = detectLanguage();
  window.history.replaceState(null, '', `${buildPath(detected, pathname)}${search}${hash}`);
  return detected;
};

export const fetchElement = async (itemId, token) => {
  const headers = {
    'Content-Type': 'application/json'
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  const response = await fetch(`${process.env.REACT_APP_API_HOST}/periodic/element/${itemId}`, {
    method: 'GET',
    headers
  });
  return response.json();
};

const lang = getInitialLanguage();
const token = getAuthCookie();
const elementId = NO_LANG_PATHS.includes(window.location.pathname)
  ? null
  : Number(parsePath(window.location.pathname).rest.match(/^\/element\/(\d+)\/?$/)?.[1]) || null;

let preloadedElement = null;

export const startup = {
  lang,
  isReady: false,
  isAuthenticated: false,
  allElements: undefined
};

startup.ready = Promise.all([
  applyLanguage(lang).catch(error => console.error(error)),
  // страницы в отдельных чанках (таблицы, настройки, калькуляторы) — чанк текущего адреса
  Promise.resolve(preloadPageForPath(window.location.pathname)).catch(error => console.error(error)),
  fetchIsAuth(),
  getAllElements(token),
  elementId
    ? fetchElement(elementId, token)
      .then(data => {
        preloadedElement = data;
      })
      .catch(error => console.error(error))
    : null
]).then(([, , isAuthenticated, allElements]) => {
  startup.isReady = true;
  startup.isAuthenticated = isAuthenticated;
  startup.allElements = allElements;
});

// Данные элемента, загруженные при старте (null — если их нет или они для другого элемента)
export const getPreloadedElement = itemId => (preloadedElement?.number === itemId ? preloadedElement : null);

// После первого показа страница элемента грузит данные сама (например, после привязки по QR — уже pro)
export const releasePreloadedElement = () => {
  preloadedElement = null;
};
